import { PROVINCE_OPTIONS } from 'variables/options';

import type { ActurisContactDetails } from 'api/quote-marketplace';

type FormatAddressInput = Pick<
  ActurisContactDetails,
  | 'street_address'
  | 'street_address_2'
  | 'city'
  | 'province'
  | 'postal_code'
  | 'country'
>;

export const formatAddress = (
  address: FormatAddressInput | null | undefined,
): string | null => {
  if (!address) {
    return null;
  }

  const {
    street_address,
    street_address_2,
    city,
    province,
    postal_code,
    country,
  } = address;

  const provinceName =
    PROVINCE_OPTIONS.find((option) => option.value === province)?.label ?? '';

  const lines = [
    street_address,
    street_address_2,
    city,
    [provinceName, postal_code].filter(Boolean).join(' '),
    country,
  ].filter(Boolean);

  return lines.join(', ') || null;
};
